<template>
  <div class="message-container">
    <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
    <ots-refer
      :selectList="selectList"
      :request-form="selectForm"
      @search="getResult"
    />
    <div class="mainCon">
      <ots-table-group
        :tableHeader="tableHeader"
        :tableOption="tableOption"
        :tableData="tableData"
        :batchOperBtn="batchOperBtn"
        :pagination="pagination"
        @changeNum="changeSize"
        @changePage="changePage"
        @handleSelectionChange="bachOper"
      ></ots-table-group>
    </div>


    <ots-custom-dialog
      :dialog.sync="sendDialog"
      title="短信明细"
      width="40%"
    >
      <template v-slot:content>
        <div class="export-setting">
          <div>本次将为<span class="col_red">{{multipleSelectList.length}}</span>位学生发送短信</div>
          <div class="">
            <p class="mt10 resendMessage">
              是否确认重新发送短信
            </p>
          </div>
        </div>
      </template>
      <template v-slot:footer class="istrue">
        <el-button round @click="sendDialog = false">取消</el-button>
        <el-button round type="primary" @click="isReSendMessage">确定</el-button>
      </template>
    </ots-custom-dialog>

  </div>
</template>

<script>
import { reSendMessageFn, getMessageRecordListInfo, exportMessageRecordFn } from '@/http/modules/applySet/message'
import {getQueryAllSchool} from '@/http/modules/school'
import {getQueryAllStation} from '@/http/modules/station'
export default {
  name: 'messagePush',
  data () {
    return {
      // 租户一次可发送短信条数
      messageNumber: "",
      // 遮罩层
      sendDialog: false,
      mainTopBtnList: [
        {
          title: '导出',
          fn: this.exportMessageRecord
        }
      ],
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "发送状态",
          type: "select",
          requestKey: "state",
          label: "key",
          value: "value",
          data: [
            {
              key: "全部",
              value: "",
            },
            {
              key: "成功",
              value: "1",
            },
            {
              key: "失败",
              value: "2",
            },
            {
              key: "发送中",
              value: "0",
            },
          ],
        },
        {
          title: "短信类型",
          type: "select",
          requestKey: "sendType",
          label: "key",
          value: "value",
          data: [
            {
              key: "全部",
              value: ""
            },
            {
              key: "自动督导",
              value: "1",
            },
            {
              key: "手动督导",
              value: "2",
            },            
            {
              key: "验证码",
              value: "3",
            },
          ],
        },
        {
          title: "发送功能",
          type: "select",
          requestKey: "actionType",
          label: "key",
          value: "value",
          data: [
            {
              key: "全部",
              value: "",
            },
            {
              key: "短信督导",
              value: "1",
            },
            {
              key: "报名审核",
              value: "2",
            },            
            {
              key: "找回密码",
              value: "3",
            },
            {
              key: "手机登录",
              value: "4",
            },
            {
              key: "注册账号",
              value: "5"
            }
          ],
        },
        {
          title: "学校",
          type: "select",
          requestKey: "schoolId",
          label: "key",
          value: "value",
          data: [],
        },
        {
          title: "函授站",
          type: "select",
          requestKey: "stationId",
          label: "key",
          value: "value",
          data: [],
        },
        {
          title: "证件号",
          type: "input",
          requestKey: "cardNo",
          placeholder: "请输入",
        },
        {
          title: "姓名",
          type: "input",
          requestKey: "realName",
          placeholder: "请输入",
        },
        {
          title: "手机号",
          type: "input",
          requestKey: "phone",
          placeholder: "请输入",
        },
        {
          title: "发送时间",
          type: "datetimerange",
          requestKey: "datetimerange",
          pickerOptions: {
            shortcuts: [
              {
                text: "今天",
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  picker.$emit("pick", [start, end]);
                },
              },
              {
                text: "昨天",
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24);
                  picker.$emit("pick", [start, end]);
                },
              },
              {
                text: "最近一周",
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit("pick", [start, end]);
                },
              },
            ],
          },
        },
                {
          title: "操作时间",
          type: "datetimerange",
          requestKey: "datetimerange2",
          pickerOptions: {
            shortcuts: [
              {
                text: "今天",
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  picker.$emit("pick", [start, end]);
                },
              },
              {
                text: "昨天",
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24);
                  picker.$emit("pick", [start, end]);
                },
              },
              {
                text: "最近一周",
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit("pick", [start, end]);
                },
              },
            ],
          },
        },
      ],
      selectForm: {
        // 批次 id
        planId: '',
        // 发送状态(默认成功)
        state : "1",
        // 短信类型
        sendType : "",
        // 发送功能
        actionType: "",
        // 学校
        schoolId: "",
        // 函授站
        stationId: "",
        // 证件号
        cardNo: "",
        // 姓名
        realName: "",
        // 手机号
        phone: "",
        
        sendBeginDate:"",
        sendEndDate:"",
        actionBeginDate: "",
        actionEndDate: "",
        page: 1,
        size: 10,
      },
      // 没啥用
      tempSelecForm: {
        state: '1',
        payState: '0',
        planId: null,
        courseId: '',
        stationId: '',
        realName: "",
        orders: "",
        cardNo: "",
      },
      content: `{学生姓名}您好，`,
      tableHeader: [
        {
          title: "考试批次",
          prop: "planName"
        },
        {
          title: "学校",
          prop: "schoolName",
        },
        {
          title: '函授站',
          prop: 'stationName'
        },
        {
          title: "姓名",
          prop: "realName",
        },
        {
          title: "证件号",
          prop: "cardNo",
        },
        {
          title: "手机号",
          prop: "phone",
        },
        {
          title: "发送时间",
          prop: "sendTime",
        },
        {
          title: "发送内容",
          prop: "content",
        },
        {
          title: "发送状态",
          prop: "state",
        },
        {
          title: "失败原因",
          prop: "failReason",
        },
        {
          title: "短信类型",
          prop: "sendType",
        },
        {
          title: "操作功能",
          prop: "actionType",
        },
        {
          title: "操作时间",
          prop: "actionTime",
        },
      ],
      tableOption: {
        multiple: true,
        // 只有成功/失败的才可以重新发送
        selectTable (row) {
          return row.state !== "发送中"
        }
      },
      multipleSelectList: [],
      tableData: [],
      batchOperBtn: [
        {
          title: "重新发送",
          icon: "iconfont icon-duanxindudao",
          click: this.resendMessage
        },
      ],
      pagination: {
        total: 0,
      },
      Ids: "",
    }
  },
  watch: {
    /********************
     * @this ： 时间监听
     ********************/
    "selectForm.datetimerange"(val) {
      if (val && val.length) {
        this.selectForm.sendBeginDate = val[0];
        this.selectForm.sendEndDate = val[1];
      } else {
        this.selectForm.sendBeginDate = "";
        this.selectForm.sendEndDate = "";
      }
    },
    "selectForm.datetimerange2"(val) {
      if (val && val.length) {
        this.selectForm.actionBeginDate = val[0];
        this.selectForm.actionEndDate = val[1];
      } else {
        this.selectForm.actionBeginDate = "";
        this.selectForm.actionEndDate = ""; 
      }
    },
  },
  mounted() {
    this.initData();
    this.getMessageNumber();
    /**************************
     * @this : 获取学校列表 (启用)
     **************************/
    getQueryAllSchool({state: 1}).then(res => {
      if (res.code) {
        for(let i=0;i<this.selectList.length;i++){
          if(this.selectList[i].requestKey == "schoolId"){
            this.selectList[i].data.push({value: '', key: '全部'});
            res.data.map(e => {
              let obj = {};
              obj.value = e.id;
              obj.key = e.name;
              this.selectList[i].data.push(obj);
            });
          }
        }
      }
    });

    /**************************
     * @this : 获取函授站列表(启用)
     **************************/
    getQueryAllStation({state: 1}).then(res => {
      if (res.code){
        for(let i=0;i<this.selectList.length;i++){
          if(this.selectList[i].requestKey == "stationId"){
            this.selectList[i].data.push({value: '', key: '全部'});
            res.data.map(e => {
              let obj = {};
              obj.value = e.id;
              obj.key = e.name;
              this.selectList[i].data.push(obj);
            })
          }
        }        
      }
    });
  },

  methods: {
    /**************************
     * @this :  重新发送短信事件
     **************************/
    resendMessage(){
      if( this.multipleSelectList.length > 0){
        this.sendDialog = true;
      } else {
        this.$message.warning("请勾选重新发送的短信")
      }
    },

    isReSendMessage(){
      // 判断租户一次发送的数量是否超量
      if(this.multipleSelectList.length > this.messageNumber && this.messageNumber != 0){
        this.$message.error(`发送失败！您发送短信的余额不足，余额剩余${this.messageNumber}条！`);
      } else {
        this.multipleSelectList.map(e => {
          this.Ids += e + ",";
        });
        if(this.Ids){
          reSendMessageFn({
            ids: this.Ids,
            planId: this.selectForm.planId
          }).then(res => {
            if(res.code == 1){
              this.Ids = "";
              this.$message.success("重新发送成功");
              this.getTableList();
              this.sendDialog = false;
            }
          }).catch(error => {
            this.Ids = "";
            this.sendDialog = false;
          })   
        }
      }
    },

    /**************************
     * @this : 获取租户可发送的短信条数
     **************************/ 
    getMessageNumber(){
      this.$api.system.getConfigMessageInfo().then( res => {
        res.data.forEach(e => {
          if(e.setName == "maxNumber"){
            this.messageNumber = e.setValue;
          }
        });
      })
    },

    /**************************
     * @this : 获取表单提交信息
     **************************/
    getResult() {
      this.selectForm.page = 1
      this.getTableList();
    },
    
    /**************************
     * @this : 导出按钮绑定事件
     **************************/
    exportMessageRecord() {
      exportMessageRecordFn(this.selectForm).then(res => {
        window.open(res.data);
      })
    },

    /**************************
     * @this : 获取考试批次id
     **************************/
    initData() {
      this.mixin_getSelectPlan().then((data) => {
        let dataList = [
          {
            id: '',
            name: '全部'
          },
          ...data,
        ]
        this.$set(this.selectList[0], "data", dataList);
        this.getTableList();
      });
    },

    /**************************
     * @this : 配置调用接口参数
     **************************/
    dealParamsWithArray(obj) {
      let params = { ...obj }
      for (let item in params) {
        if (Array.isArray(params[item])){
          delete params[item]
        }
      }
      return params
    },

    /**************************
     * @this : 调用接口,获取表格数据
     **************************/
    getTableList() {
      let params = this.dealParamsWithArray(this.selectForm)
      getMessageRecordListInfo(params).then(res => {
        this.tableData = res.data.records
        this.pagination.total = res.data.total
      })
    },

    /**************************
     * @this : table 列表 选择 事件
     **************************/
    bachOper(res) {
      this.multipleSelectList = res.map((item) => {
        return item.id;
      });
    },

    /**************************
     * page 分页......
     **************************/
    changeSize(num) {
      this.selectForm.size = num;
      this.getTableList();
    },
    changePage(p) {
      this.selectForm.page = p;
      this.getTableList();
    },
  }
}
</script>

<style lang="less" scoped>
.mainCon {
  margin-top: 16px;
  padding: 24px;
  background: #fff;
  border-radius: 8px;
}
.resendMessage{
  font-size:20px;
  font-weight:700;
  color:#303133;
}
</style>